import { CdkScrollable } from "@angular/cdk/scrolling";
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from "@angular/forms";
import { TooltipModule } from "@cloudfactorydk/ng2-tooltip-directive";
import { IonicModule } from "@ionic/angular";
import { NgxFileDropModule } from "ngx-file-drop";
import { LottieComponent } from 'ngx-lottie';
import { ComponentsModule } from "../components/components.module";
import { DeleteFolderConfirmationComponent } from "../components/delete-folder-confirmation/delete-folder-confirmation.component";
import { DesktopHeaderComponentModule } from "../shared/desktop-header/desktop-header.module";
import { ElementResizeDirective } from "../shared/directives/element-resize-directive";
import { QtyStepperModule } from "../shared/shop/qty-stepper/qty-stepper.module";
import { SliderModule } from "../shared/widgets/slider/slider.module";
import { BindingOptionsModule } from "./binding-options/binding-options.module";
import { CancellingUploadsModalComponent } from "./cancelling-uploads-modal/cancelling-uploads-modal.component";
import { FilesContainerModule } from "./files-container/files-conatiner.module";
import { FinishingSettingsSectionComponent } from "./finishing-settings-section/finishing-settings-section.component";
import { GeneralSettingsSectionComponent } from "./general-settings-section/general-settings-section.component";
import {
  CurrentPrintgroupStatusBarComponent
} from "./home-main-content-section/current-printgroup-status-bar/current-printgroup-status-bar.component";
import {
  UploadFilesOptionsComponent
} from "./home-main-content-section/upload-files-options/upload-files-options.component";
import { HomeNewComponent } from "./home-new.component";
import { HomeSettingsSectionComponent } from "./home-settings-section/home-settings-section.component";
import { HomeSummarySectionComponent } from "./home-summary-section/home-summary-section.component";
import {
  PrintGroupFolderItemComponent
} from "./home-summary-section/print-group-folder-item/print-group-folder-item.component";
import { MobileButtonsBarComponent } from "./mobile-buttons-bar/mobile-buttons-bar.component";
import { MobileHomeFoldersComponent } from "./mobile-home-folders/mobile-home-folders.component";
import { MobileHomeSummaryComponent } from "./mobile-home-summary/mobile-home-summary.component";
import { OptionsButtonModule } from "./options-button/options-button.module";
import { UploadingFilesModalComponent } from "./uploading-files-modal/uploading-files-modal.component";


@NgModule({
  declarations: [
    HomeNewComponent,
    GeneralSettingsSectionComponent,
    FinishingSettingsSectionComponent,
    HomeSettingsSectionComponent,
    HomeSummarySectionComponent,
    UploadFilesOptionsComponent,
    CurrentPrintgroupStatusBarComponent,
    PrintGroupFolderItemComponent,
    DeleteFolderConfirmationComponent,
    MobileButtonsBarComponent,
    MobileHomeSummaryComponent,
    MobileHomeFoldersComponent,
    UploadingFilesModalComponent,
    CancellingUploadsModalComponent,
  ],
  imports: [
    CommonModule,
    ComponentsModule,
    DesktopHeaderComponentModule,
    IonicModule,
    NgxFileDropModule,
    TooltipModule,
    FilesContainerModule,
    QtyStepperModule,
    FormsModule,
    LottieComponent,
    OptionsButtonModule,
    BindingOptionsModule,
    SliderModule,
    CdkScrollable,
    ElementResizeDirective
  ],
  exports: [
    PrintGroupFolderItemComponent,
    CdkScrollable,
  ]
})
export class HomeNewModule {
}
